var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mg-time-left"},[(!_vm.meeting)?_c('span',[_c('b',{staticClass:"mr-1"},[_vm._v("Chat has not started yet")])]):(_vm.timeExpired)?_c('span',[_c('b',{staticClass:"urgent mr-1"},[_vm._v("Chat expired")])]):_c('span',[_vm._v(" Ends in "),_c('b',{class:`${_vm.showTimeUrgency} mr-1`},[_vm._v(_vm._s(_vm.showTimeRemaining))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }